import { atom } from "jotai";

export const uploadingDataState = atom(false);